<template>
  <div  :class="['main-content','sn-content']">
    <el-card v-if="user.status == '2'" class="box-card">
      <div>
        <div class="vertical">
          <i  class="el-icon-warning-outline" style="color: orange"></i>
          <router-link  :to="{path:'/uac/authc'}"  style="color: orange">去认证</router-link>
        </div>
        <p class="tag" style="">企业用户请先进行账号认证，认证通过后，才可以申请代理转发服务</p>
      </div>
    </el-card>

    <div v-else>
      <el-form ref="form" :model="form" :rules="rules" >
        <div class="box-card is-always-shadow">

          <el-form-item label="" prop="lanIp"  class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span style="width: 200px">内网ip+端口号</span>
            </div>
            <el-input placeholder="服务器的内网ipv4地址，例如192.168.0.28" v-model="form.lanIp" style="width: 300px;"></el-input>
            <span style="margin: 0 10px;">:</span>
            <el-input  placeholder="LarkXR的端口号，默认为8181" v-model="form.lanPort" style="width: 80px;"></el-input>
          </el-form-item>
          <el-form-item label="" prop="connCnt"  class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span style="width: 200px">并发数</span>
            </div>
            <el-input-number :disabled="user.role != 30" style="display: inline-block;float: none" v-model="form.connCnt" @change="handleChangeConnCnt" :min="1" :max="10" label="系统支持的最大并发数"></el-input-number>
            <el-tooltip  v-if="user.role != 30" effect="light" placement="top-start">
              <div slot="content" class="tip-info">
                表示使用代理转发服务时最多支持多少并发。
                暂时不支持修改，若需要多个并发，可致电平行云专属客户经理。400-678-1024
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
          </el-form-item>
        <el-form-item label="" prop="note"  class="pxy-form-item pxy-form-item-line">
          <div class="pxy-tag-label">
            <span style="width: 200px">备注</span>
          </div>
          <el-input placeholder="" v-model="form.note" style="width:500px"></el-input>
        </el-form-item>

        </div>
      </el-form>
      <div class="price-detail">
        <div class="item">
          <div  v-for="(item, index) in basicItemList" v-if="item.checkStatus">
            <span class="title">{{item.itemName}}：</span>
            <span class="unit">￥</span>
            <span class="price">{{item.price}}</span>
            <span class="unit"> {{item.priceUnit}}</span>
          </div>
          <el-divider></el-divider>
            <div  v-for="(item, index) in commItemList" v-if="item.checkStatus">
              <span class="title">{{item.itemName}}：</span>
              <span class="unit">￥</span>
              <span class="price"> {{form.connCnt}}×{{item.price}}= {{form.connCnt * item.price}}</span>
              <span class="unit"> {{item.priceUnit}}</span>
          </div>
        </div>
        <div  class="item" style="">
          <el-button type="primary" class="pxy-primary" plain @click="addAgentInfo()">确认</el-button>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import {Message} from "element-ui";

  export default {
    components: {},
    data() {
      return {
        loading: false,
        agentProdItemList:[],
        commItemList: [], //按量计费的计价规则
        commPrice :0,
        basicItemList: [], //Basic计价规则
        form: {
          clientId: this.$route.query.clientId,
          lanAddress: '',
          lanIp:'',
          lanPort:'8181',
          note:'',
          connCnt:1
        },
        rules: {
          note: [ {
            required: true,
            message: "请输入备注",
            trigger: 'blur'
          },{max: 30, message: "长度在30个字符以内", trigger: 'blur'}],
        lanAddress: [ {
          required: true,
          message: "请输入内网地址",
          trigger: 'blur'
        },{max: 30, message: "长度在30个字符以内", trigger: 'blur'}],
          lanIp: [ {
            required: true,
            message: "请输入内网地址",
            trigger: 'blur'
          },{max: 26, message: "长度在26个字符以内", trigger: 'blur'}],
          lanPort: [ {
            required: true,
            message: "请输入端口号",
            trigger: 'blur'
          },{max: 10, message: "长度在10个字符以内", trigger: 'blur'}],
        },

        // 增值服务的开启数量
        extraCnt: 0,
      }
    },
    created() {
    },
    methods: {
      getProcProdItem: function () {
        this.getRequest('/pocPriceItem/list', {"type": 6}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.agentProdItemList = resp.data.result;
              this.basicItemList = this.agentProdItemList.filter(item => item.id == '1302725665837023232');
              this.commItemList = this.agentProdItemList.filter(item => item.id == '1302725665837023233');
              this.basicItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', true);
              })
              this.commItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', true);
                this.$set(item, 'cnt', 1);
              })
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      addAgentInfo: function () {
        var _this = this;
        var params = {};
        params.clientId = _this.form.clientId;
        params.name = _this.form.name;
        params.note =  _this.form.note;
        params.connCnt =  _this.form.connCnt;
        params.lanAddress = _this.form.lanIp + ":" + _this.form.lanPort;
        if(this.$route.query.userId){
          params.userId = this.$route.query.userId;
        }
        params.serviceItemList =  this.basicItemList.filter(item => item.checkStatus);
        params.serviceItemList1 =  this.commItemList.filter(item => item.checkStatus);
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$confirm('请知悉：访问页面或者进入应用会按照使用时长，按分钟计费。', '温馨提示', {
              confirmButtonText: '知道了',
              /*     cancelButtonText: '关闭',*/
              type: 'warning',
              center: true
            }).then(() => {
              _this.doAdd(params);
            }).catch(() => {

            });

          }
        })
      },
      doAdd: function (params) {
        this.loading = true;
        this.postRequestJson('/pocTurnPortMappings/add', JSON.stringify(params)).then(resp => {
          this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              Message.success(data.message);
              this.$router.replace({path: '/agent/index'});

            } else {
              Message.error(data.message);

            }
          }
        });
      },
      changeContentHeight:function(flag){
        if(flag){
          this.extraCnt += 1;
        }else {
          this.extraCnt -= 1;
        }
        this.heightC = 'heightN'+this.extraCnt;
      },
      handleChangeConnCnt: function (e) {
        this.commItemList.forEach((item, index) => {
          this.$set(item, 'cnt', e);
        })
      }
    }
    ,
    mounted: function () {
      this.getProcProdItem();
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    padding: 20px;

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
